import { render, staticRenderFns } from "./AgentData.vue?vue&type=template&id=120d98f8&"
import script from "./AgentData.vue?vue&type=script&lang=js&"
export * from "./AgentData.vue?vue&type=script&lang=js&"
import style0 from "./AgentData.vue?vue&type=style&index=0&id=120d98f8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports